import { FeedFilterValues } from '@capsicum/common';
import { FeedFiltersType } from '@capsicum/socios-core';
import { atom } from 'jotai';

import { type FeedFiltersAtomType } from '../../models';

export const defaultFilterAtomValue = {
	selectedFilters: [FeedFilterValues.ALL]
};

export const favouriteTeamFeedFiltersAtom = atom<FeedFiltersAtomType>(defaultFilterAtomValue);
export const followedTeamsFeedFiltersAtom = atom<FeedFiltersAtomType>(defaultFilterAtomValue);
export const suggestedTeamsFeedFiltersAtom = atom<FeedFiltersAtomType>(defaultFilterAtomValue);

export const filterAtomTypeMap: Record<
	FeedFiltersType,
	typeof favouriteTeamFeedFiltersAtom | typeof followedTeamsFeedFiltersAtom | typeof suggestedTeamsFeedFiltersAtom
> = {
	[FeedFiltersType.FAVOURITE_TEAM]: favouriteTeamFeedFiltersAtom,
	[FeedFiltersType.FOLLOWED_TEAMS]: followedTeamsFeedFiltersAtom,
	[FeedFiltersType.SUGGESTED_FEED]: suggestedTeamsFeedFiltersAtom
};
